import { getContactRules } from "../../configs/regionalProfile";

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

/**
 * Contact-field behavior now comes from the configured regional profile rather
 * than the UI locale. v92 selected Japanese rules when `locale === "ja"` and US
 * rules otherwise, which meant a Canadian French or Indian English build would
 * have been given US postal and phone rules.
 *
 * JP and US rule values are unchanged from v92.
 *
 * Callers may still pass a locale argument; it is ignored and rules come from
 * the market profile.
 *
 * Rule sets also expose `sanitizePostal` / `sanitizePhone`, because a postal
 * code is not digits everywhere: Canada's "A1A 1A1" cannot survive a
 * digits-only pipeline. `sanitizeContactValue` below is kept for compatibility,
 * but new call sites should use the rule-set sanitizers.
 */
const getContactFieldRules = () => getContactRules();

// Retained for compatibility with any caller outside this package. Numeric
// only — do not use it for postal codes that may contain letters.
const sanitizeContactValue = (value, maxLength) =>
  digitsOnly(value).slice(0, maxLength);

export { digitsOnly, getContactFieldRules, sanitizeContactValue };
